import { OnboardingSpzBanner } from "@/features/onboarding/components/onboarding-spz-banner";
import { OnboardingSuccess } from "@/features/onboarding/components/onboarding-success";
import { OnboardingForm } from "@/features/onboarding/forms/onboarding-form";
import { routes } from "@/root";
import { type FC, useState } from "react";
import SpzLogo from "../assets/logo-spz-white-icon.svg";

type OnboardingStep = "profile" | "success";

const Onboarding: FC = () => {
  const [currentStep, setCurrentStep] = useState<OnboardingStep>("profile");

  return (
    <>
      <nav className="flex justify-center items-center bg-pink-500 h-9 lg:hidden xl:hidden 2xl:hidden">
        {/* Logo visible at 1024px and above */}
        <img src={SpzLogo} alt="Supervizor Logo" className="w-6" />
      </nav>
      <div className="grid lg:grid-cols-2 h-[calc(100vh-64px)] lg:h-screen lg:p-6">
        {/* Left Side - Banner */}
        <div className="rounded hidden lg:block bg-primary-gradient">
          <OnboardingSpzBanner className="h-full" />
        </div>

        {/* Right Side - Content */}
        <div className="w-full">
          {currentStep === "profile" ? (
            <OnboardingForm
              className="h-full"
              onSuccess={() => setCurrentStep("success")}
            />
          ) : (
            <OnboardingSuccess redirectPath={routes.root.path} />
          )}
        </div>
      </div>
    </>
  );
};

export default Onboarding;
